import axios from "axios";
import { linkUrl } from "../linkurl";

const API_URL = linkUrl;

// Get All Products
const coverpage = async () => {
  const res = await axios.get(`${API_URL}/cover`);
  if (res.data.status === 200) {
    return res.data.data;
  }
};

const settingService = {
  coverpage,
};
export default settingService;
